import { ConnectorType, ConnectorSource } from '@hum/icm-app/src/state';
import { AvailableServiceInfo } from './base';

export const paywhirlDirectConnector: AvailableServiceInfo = {
  label: 'Paywhirl',
  icon: require('./paywhirl.svg'),
  isBeta: true,
  type: ConnectorType.Paywhirl,
  source: ConnectorSource.Capital,
  fields: [
    {
      label: 'Enter your API Key',
      propertyName: 'api_key',
    },
    {
      label: 'Enter your API Secret',
      propertyName: 'api_secret',
    },
  ],
  connect: (params) => params,
};
